import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { SupplierResponse } from '../Models/Supplier';
import { DynamicFieldRequest } from '../Models/FieldEntry';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SupplierService {

  private readonly apiUrl = environment.apiUrl;

  constructor(private readonly http: HttpClient) { }

  /**
   * Fetch suppliers based on dynamic search filters.
   * Authorization header and Function Key
   * are added automatically by the HTTP Interceptor.
   */
  getSuppliers(model: DynamicFieldRequest): Observable<SupplierResponse> {
    return this.http.post<SupplierResponse>(
      `${this.apiUrl}`,
      model
    );
  }
}
